import { createFileRoute } from '@tanstack/react-router'

import styles from './styles.module.scss'
import { lazy, Suspense, useState } from 'react'
import { CardSignboard } from '@/components/ui/card-signboard'
import { useBoolean } from '@/hooks'
import { cardsServiceInstance } from '@/services/cards.service'
const DatePicker = lazy(() => import('@/components/ui/date-picker'))

export const Route = createFileRoute('/mobile/__base-layout/cards/')({
  component: RouteComponent,
  loader: async () => {
    const meCards = await cardsServiceInstance.meCards()

    return meCards
  },
  shouldReload: true,
})

function RouteComponent() {
  const cards = Route.useLoaderData()

  const [filterType, setFilterType] = useState<'all' | 'win' | 'lose'>('all')

  const filteredCards = filterType === "lose" ? cards.filter(c => c.cards.some(c => c.value <= 0)).map(c => ({
    title: c.title,
    cards: c.cards.filter(c => c.value <= 0)
  })) : cards

  const newFilters = filterType === "win" ? filteredCards.filter(c => c.cards.some(c => c.value > 0)).map(c => ({
    title: c.title,
    cards: c.cards.filter(c => c.value > 0)
  })) : filteredCards

  console.log(cards)
  const [isOpen, handleOpen, handleClose] = useBoolean()

  return (
    <div className={styles.container}>
      <header>
        <div className={styles.header_filters}>
          <h4>Minhas cartelas</h4>
          <button onClick={handleOpen}>
            <img
              src="/assets/calendar.svg"
            />
          </button>
        </div>

        <div className={styles.header_pivot}>
          <button
            className={`${filterType === 'all' && styles.active}`}
            onClick={() => setFilterType('all')}
          >
            Todas
          </button>
          <button
            className={`${filterType === 'lose' && styles.active}`}
            onClick={() => setFilterType('lose')}
          >
            Não premiadas
          </button>
          <button
            className={`${filterType === 'win' && styles.active}`}
            onClick={() => setFilterType('win')}
          >
            Premiadas
          </button>
        </div>
      </header>
      {
        newFilters.map(section => (
          <div className={styles.sections} key={section.title}>
            <h5>{section.title}</h5>
            <ul>
              {
                section.cards.map(card => (
                  <li key={card.id}>
                    <CardSignboard
                      numbers={card.cardBalls}
                      drawNumbers={card.drawNumbers}
                      cardId={card.id}
                      sequential={card.sequential}
                      cardKey={card.key}
                    />
                  </li>
                ))
              }
            </ul>
          </div>
        ))
      }
      {
        isOpen && (
          <Suspense>
            <DatePicker
              isOpen={isOpen}
              onClose={handleClose}
            />
          </Suspense>
        )
      }
    </div>

  )
}
